
import * as React from "react";
const AddCartIconSvg = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 5.11334V4.46667C5 2.96667 6.20667 1.49334 7.70667 1.35334C9.49333 1.18001 11 2.58667 11 4.34001V5.26001"
      stroke="#670001"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.99988 14.6666H9.99988C12.6799 14.6666 13.1599 13.5933 13.2999 12.2866L13.7999 8.28665C13.9799 6.65998 13.5132 5.33331 10.6666 5.33331H5.33322C2.48655 5.33331 2.01988 6.65998 2.19988 8.28665L2.69988 12.2866C2.83988 13.5933 3.31988 14.6666 5.99988 14.6666Z"
      stroke="#670001"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3306 8.00002H10.3366"
      stroke="#670001"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66268 8.00002H5.66867"
      stroke="#670001"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AddCartIconSvg;
